interface FilePreviewProps {
  fileId?: string;
}

export const FilePreview = ({ fileId }: FilePreviewProps) => {
  if (!fileId) {
    return (
      <div className="flex h-full items-center justify-center">
        <p className="text-neutral/50">No file selected</p>
      </div>
    );
  }

  return (
    <div className="@FilePreview p-6">
      <h1 className="mb-4 text-2xl font-semibold">File Preview</h1>
      <p className="text-neutral/60">File ID: {fileId}</p>
      {/* Placeholder for file preview content */}
    </div>
  );
};
